// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Client from "@apollo/client";

var Js_ = {};

var ReactiveVar = {
  Js_: Js_
};

var Js_$1 = {};

function makeVar(prim) {
  return Client.makeVar(prim);
}

export {
  ReactiveVar ,
  Js_$1 as Js_,
  makeVar ,
}
/* @apollo/client Not a pure module */
